import { RegistrationSummary } from "./RegistrationSummary";
import { RegisteringAthletes } from "./RegisteringAthletes";
import { UserForm } from "./UserForm";
import { calculateTotal } from "./paidRegistrationUtils";
import { WizardWithSummaryFormKit } from "../../forms/WizardWithSummaryFormKit";
import { TeamsSelectorField } from "./TeamsSelectorField";

export const RegistrationWizard = ({ user, athletes, options, registrationOptions, captureFields, paymentOptions, exclusiveSeries = [], register, createCheckoutSession, isSeriesRegistration, organisation }) => {
    const defaultAthletes = options.some(option => option.isTeams)
        ? []
        : exclusiveSeries.length === 0 && athletes.length === 0
            ? [{ registrations_attributes: [] }]
            : exclusiveSeries.length === 0 && athletes.length === 1 && athletes[0].registrations_attributes.every(r => !r.id)
                ? athletes
                : [];

    const initialValues = {
        athletes: defaultAthletes,
        user_attributes: {
            phone: user.phone,
            properties: user.properties
        },
        initial_athletes: athletes.map(athlete => ({ id: athlete.id, properties: athlete.properties }))
    };

    const steps = [
        registrationOptions?.teamRequired && {
            name: "Team",
            buttonLabel: "Continue",
            fields: [
                {
                    name: "team.id",
                    component: TeamsSelectorField
                }
            ]
        },
        {
            name: (isSeriesRegistration ? "Athletes" : "Entries"),
            buttonLabel: "Continue",
            component: RegisteringAthletes,
            athletes, options, registrationOptions, captureFields, paymentOptions,
            exclusiveSeries, isSeriesRegistration, organisation
        },
        {
            name: "Your details",
            buttonLabel: "Continue",
            component: UserForm,
            registrationOptions,
            captureFields,
            submit: true
        },
        !!paymentOptions && { name: "Payment" },
        { name: "Done" }
    ].filter(s => s);

    const onSubmit = values =>
        (paymentOptions && calculateTotal(values.athletes, paymentOptions).total > 0)
            ? createCheckoutSession(values)
            : register(values);

    return (
        <WizardWithSummaryFormKit
            initialStep={0}
            steps={steps}
            initialValues={initialValues}
            onSubmit={onSubmit}
            SummaryComponent={RegistrationSummary}
            summaryProps={{ paymentOptions, registrationOptions, isSeriesRegistration }}
        />
    );
};
